import React from 'react'

import { BackArrow } from '@cinch/oxd-components/icons/src'
import SVG from '@cinch/oxd-components/svg/src'

import * as styles from './back-link.module.css'

const ICON_SIZE = 20

// TODO: (EK) might extract this component to it's own package

const BackLinkComponent: React.FC<any> = ({ children, ...props }) => (
  <a className={styles.link} {...props}>
    <SVG className={styles.icon} children={BackArrow} size={ICON_SIZE} />
    <div className={styles.label}>{children}</div>
  </a>
)

export default BackLinkComponent
